import React from "react";
import CheckBalance from "@page-contents/check-balance";

export default () => <CheckBalance />;
